import { Link, useForm } from '@inertiajs/react'
import Seo from '../../components/Seo'
import { useShared } from '../../lib/hooks'

export default function Register({ return_to }: { return_to?: string | null }) {
  const { errors } = useShared()
  const form = useForm({ user: { email: '', password: '', password_confirmation: '' }, return_to: return_to ?? '' })
  const loginHref = return_to ? `/login?return_to=${encodeURIComponent(return_to)}` : '/login'

  function submit(e: React.FormEvent) {
    e.preventDefault()
    form.post('/register')
  }

  function set(key: 'email' | 'password' | 'password_confirmation', v: string) {
    form.setData('user', { ...form.data.user, [key]: v })
  }

  return (
    <>
      <Seo title="Create account" noindex />
      <div className="mx-auto max-w-md px-4 sm:px-6 py-16">
        <div className="mono-label mb-3">Account</div>
        <h1 className="text-3xl font-semibold tracking-tight">Create account</h1>
        <p className="mt-2 text-muted text-sm">One account to buy and re-download your packs anytime.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <Field label="Email" type="email" autoComplete="email" value={form.data.user.email} onChange={(v) => set('email', v)} error={errors?.email} required />
          <Field label="Password" type="password" autoComplete="new-password" value={form.data.user.password} onChange={(v) => set('password', v)} error={errors?.password} required />
          <Field label="Confirm password" type="password" autoComplete="new-password" value={form.data.user.password_confirmation} onChange={(v) => set('password_confirmation', v)} error={errors?.password_confirmation} required />

          <button
            type="submit"
            disabled={form.processing}
            className="w-full h-12 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition disabled:opacity-60"
          >
            {form.processing ? 'Creating…' : 'Create account'}
          </button>
        </form>

        <p className="mt-6 text-sm text-muted">
          Already have an account?{' '}
          <Link href={loginHref} className="text-paper hover:underline">Sign in</Link>
        </p>
      </div>
    </>
  )
}

function Field({
  label,
  type,
  value,
  onChange,
  autoComplete,
  required,
  error,
}: {
  label: string
  type: string
  value: string
  onChange: (v: string) => void
  autoComplete?: string
  required?: boolean
  error?: string
}) {
  return (
    <label className="block">
      <span className="mono-label">{label}</span>
      <input
        type={type}
        value={value}
        autoComplete={autoComplete}
        required={required}
        onChange={(e) => onChange(e.target.value)}
        className={`mt-1.5 w-full h-12 bg-ink-soft border outline-none px-3.5 text-paper transition-colors ${error ? 'border-red-500/60' : 'border-line focus:border-paper'}`}
      />
      {error && <span className="mt-1 block text-xs text-red-400">{error}</span>}
    </label>
  )
}
